import { render, staticRenderFns } from "./NccQuestionApp.vue?vue&type=template&id=52833a13&"
import script from "./NccQuestionApp.vue?vue&type=script&lang=js&"
export * from "./NccQuestionApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/staging.newcitycatechismus.nl/httpdocs/web/app/themes/wp-subsite-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52833a13')) {
      api.createRecord('52833a13', component.options)
    } else {
      api.reload('52833a13', component.options)
    }
    module.hot.accept("./NccQuestionApp.vue?vue&type=template&id=52833a13&", function () {
      api.rerender('52833a13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/QNA/NccQuestionApp.vue"
export default component.exports